import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const CalendarStateTrueIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "CalendarStateTrueIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M16.2123 22C13.2506 22 10.8407 19.6037 10.8407 16.6577C10.8407 14.0158 12.8218 11.7418 15.4491 11.3691C16.1017 11.2655 16.7217 11.731 16.8161 12.3883C16.9105 13.0456 16.4513 13.6549 15.7904 13.7479C14.3467 13.9533 13.258 15.2042 13.258 16.6577C13.258 18.2784 14.5832 19.5959 16.2123 19.5959C17.6098 19.5959 18.8273 18.6099 19.1071 17.2504C19.2418 16.6009 19.885 16.1843 20.5336 16.3144C21.1876 16.4474 21.609 17.0831 21.4752 17.7336C20.9658 20.2052 18.7526 22 16.2123 22Z"
        fill="url(#paint0_linear_23_9493)"
      />
      <path
        d="M16.2536 18.3948C15.9335 18.3948 15.6257 18.2686 15.399 18.0426L14.5842 17.2318C14.1121 16.7623 14.1126 16.0014 14.5847 15.5319C15.0282 15.0908 15.7299 15.0634 16.2049 15.4527L18.3788 13.0563C18.8263 12.5634 19.5895 12.5243 20.0856 12.9693C20.5813 13.4133 20.6206 14.1733 20.1736 14.6663L17.151 17.9977C16.9287 18.2422 16.6155 18.386 16.2846 18.3938C16.2743 18.3948 16.2639 18.3948 16.2536 18.3948Z"
        fill="url(#paint1_linear_23_9493)"
      />
      <path
        d="M19.7598 6.40044C19.9471 6.40044 20.1005 6.23018 20.0593 6.04847C19.7441 4.65868 18.5081 3.61777 17.0153 3.61777H16.2433V3.20208C16.2433 2.53795 15.7019 2 15.0346 2C14.3673 2 13.8259 2.53795 13.8259 3.20208V3.61777H8.82654V3.20208C8.82654 2.53795 8.28515 2 7.61787 2C6.95059 2 6.4092 2.53795 6.4092 3.20208V3.61777H5.6367C4.14397 3.61777 2.90807 4.6587 2.59307 6.04851C2.55188 6.23022 2.70528 6.40044 2.89257 6.40044H19.7598Z"
        fill="url(#paint2_linear_23_9493)"
      />
      <path
        d="M2.5 8.46832V17.3443C2.5 19.0675 3.90458 20.4644 5.63721 20.4644H8.70783C9.41039 20.4644 9.89307 19.7689 9.64502 19.1152C9.1154 17.7193 9.02492 16.1304 9.58152 14.5022C10.3091 12.3739 12.0637 10.6769 14.236 10.0558C15.8326 9.59921 17.401 9.72707 18.7698 10.2749C19.4327 10.5402 20.1525 10.0637 20.1525 9.35301L20.1525 8.46832C20.1525 8.30238 20.0172 8.16786 19.8504 8.16786H2.80212C2.63526 8.16786 2.5 8.30237 2.5 8.46832Z"
        fill="url(#paint3_linear_23_9493)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_23_9493"
          x1="2.5"
          y1="13.8478"
          x2="21.5"
          y2="13.8478"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DD3422" />
          <stop offset="1" stopColor="#FC3B26" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_23_9493"
          x1="2.5"
          y1="13.8478"
          x2="21.5"
          y2="13.8478"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DD3422" />
          <stop offset="1" stopColor="#FC3B26" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_23_9493"
          x1="2.5"
          y1="13.8478"
          x2="21.5"
          y2="13.8478"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DD3422" />
          <stop offset="1" stopColor="#FC3B26" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_23_9493"
          x1="2.5"
          y1="13.8478"
          x2="21.5"
          y2="13.8478"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DD3422" />
          <stop offset="1" stopColor="#FC3B26" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default CalendarStateTrueIcon;
